import { STATUSES } from '@/constants/common/message.constants'

import { type PackageCategoryImportJobExEntity } from '../../aspida/@types'

/**
 * 荷姿取込ステータス
 */
export type PackageCategoryImportJobStatusType =
  PackageCategoryImportJobExEntity['status']

export const PACKAGE_CATEGORY_IMPORT_JOB_STATUS_TYPE = {
  /** 取込待ち */
  PENDING: 'PENDING',
  /** 取込中 */
  IMPORTING: 'IMPORTING',
  /** 完了 */
  COMPLETED: 'COMPLETED',
  /** エラー */
  ERROR: 'ERROR'
} as const satisfies Record<
  PackageCategoryImportJobStatusType,
  PackageCategoryImportJobStatusType
>

export const PACKAGE_CATEGORY_IMPORT_JOB_STATUS_TYPE_LABEL = {
  [PACKAGE_CATEGORY_IMPORT_JOB_STATUS_TYPE.PENDING]: STATUSES.PENDING,
  [PACKAGE_CATEGORY_IMPORT_JOB_STATUS_TYPE.IMPORTING]: STATUSES.PROCESSING,
  [PACKAGE_CATEGORY_IMPORT_JOB_STATUS_TYPE.COMPLETED]: STATUSES.COMPLETED,
  [PACKAGE_CATEGORY_IMPORT_JOB_STATUS_TYPE.ERROR]: STATUSES.FAILED
} as const satisfies Record<PackageCategoryImportJobStatusType, string>
